module.exports = __webpack_public_path__ + "media/images/flags/iq-e513b61351a192b7a964d6b0479b6735.svg";